<template>
  <div>
    <div class="container-xl">
      <div class="section-manufacturing__title">
        <div class="inner">
          <h2 class="title">
            {{ subSections[currentSubsection].title }}
          </h2>
        </div>

        <p v-if="subSections[currentSubsection].description" class="text title--small ">
          {{ subSections[currentSubsection].description }}
        </p>
      </div>
      <SubsectionNavLeft :currentComponent="subSections[currentSubsection]" gtmSubsection="ManufacturingBenefits"
        parent="Why Digital" :subSections="subSections" @click-subnav="changeTab">
        <component :data="getData" :is="subSections[currentSubsection].component" />
      </SubsectionNavLeft>
    </div>
    <ShareButton
      :shareLink="`https://admin-corrugated.hp-blueprint.com/assets/a9fee7b1-4a8b-4f4b-916a-e1d252ee83db.pdf`"
      shareLabel="Why digital - Manufacturing Benefits" :hash="hashify(`Why digital - Manufacturing Benefits`)"
      @share-this="shareThis" />
  </div>
</template>

<script>
import * as endpoints from '@/common/endpoints';
import { filters, defaultMixins } from '@/common/mixins';

import ShareButton from '@/components/ui/ShareButton.vue';
import SubsectionNavLeft from '@/layout/SubsectionNavLeft.vue';
import Scenarios from './manufacturing-benefits/Scenarios.vue';
import CorrugationVideo from './manufacturing-benefits/CorrugationVideo.vue';

export default {
  name: 'ManufacturingBenefits',
  mixins: [filters, defaultMixins],
  components: {
    ShareButton,
    SubsectionNavLeft,
    Scenarios,
    CorrugationVideo,
  },
  data() {
    return {
      baseURL: endpoints.BASEURL,
      currentSubsection: 0,
    };
  },
  methods: {
    changeTab(payload) {
      this.currentSubsection = payload.id;
    },
  },
  mounted() {
    // Disable navigation if currentPrinter is not 3
    if (this.$store.state.currentPrinter !== 3) {
      this.$router.replace('/why-digital');
    }
    this.$watch(
      () => this.$store.state.currentPrinter,
      (newVal) => {
        if (newVal !== 3) {
          this.$router.replace('/why-digital');
        }
      },
    );
  },
  computed: {
    subSections() {
      return [
        {
          id: 0,
          component: 'Scenarios',
          label: 'T700i DigiLam Economics',
          description: '',
          title: 'Economical DigiLam production with the HP PageWide T700i Press​',
        },
        {
          id: 1,
          component: 'CorrugationVideo',
          label: 'Batch Corrugation Video',
          description: '',
          title: 'Economical DigiLam production with the HP PageWide T700i Press',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/views/about/base.scss';

.section-manufacturing__title {
  margin: 0;
  padding-left: 300px;
  width: 100%;
  max-width: 100%;
  text-align: center;

  .inner {
    max-width: 700px;
    margin: 0 auto;
  }
}
</style>
